"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.streamStateWasteCodes = streamStateWasteCodes;
/**
 * Every state code a stream is known by: what its manifests reported and what
 * its profile claims. Either is enough for a state to treat it as acute.
 */
function streamStateWasteCodes(stream) {
    if (stream === null)
        return [];
    return [
        ...(stream.profile?.stateWasteCodes ?? []),
        ...stream.rawWasteStreams.flatMap((raw) => raw.stateWasteCodes),
    ];
}
//# sourceMappingURL=streamStateWasteCodes.js.map